import { FunctionComponent, useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { CreateTeam, CreateTeamForm } from './CreateTeam';
import { SelectTeam } from './SelectTeam';

export interface SelectCreateTeamCardProps {
  onSubmitting?: (isSubmitting: boolean) => void;
}

export const SelectCreateTeamCard: FunctionComponent<
  SelectCreateTeamCardProps
> = ({ onSubmitting }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid, isSubmitting },
  } = useForm<CreateTeamForm>({
    mode: 'onChange',
    defaultValues: {
      name: '',
    },
  });

  useEffect(() => {
    if (onSubmitting) {
      onSubmitting(isSubmitting);
    }
  }, [isSubmitting, onSubmitting]);

  return (
    <div className="flex flex-col">
      <SelectTeam />
      <div className="flex flex-row items-center">
        <hr className="w-1/2 mx-os1-spacing" />
        <span className="text-xs">or</span>
        <hr className="w-1/2 mx-os1-spacing" />
      </div>
      <CreateTeam
        errors={errors}
        handleSubmit={handleSubmit}
        isValid={isValid}
        register={register}
        reset={reset}
      />
    </div>
  );
};
